import { create } from 'zustand';

export type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'reconnecting' | 'error';

interface WsState {
  connectionStatus: ConnectionStatus;
  subscribedChannels: Set<string>;
  reconnectAttempts: number;

  setConnectionStatus: (status: ConnectionStatus) => void;
  subscribe: (channel: string) => void;
  unsubscribe: (channel: string) => void;
  clearSubscriptions: () => void;
  incrementReconnectAttempts: () => void;
  resetReconnectAttempts: () => void;
}

export const useWsStore = create<WsState>()((set) => ({
  connectionStatus: 'disconnected',
  subscribedChannels: new Set<string>(),
  reconnectAttempts: 0,

  setConnectionStatus: (status) => set({ connectionStatus: status }),

  subscribe: (channel) =>
    set((state) => {
      const channels = new Set(state.subscribedChannels);
      channels.add(channel);
      return { subscribedChannels: channels };
    }),

  unsubscribe: (channel) =>
    set((state) => {
      const channels = new Set(state.subscribedChannels);
      channels.delete(channel);
      return { subscribedChannels: channels };
    }),

  clearSubscriptions: () =>
    set({ subscribedChannels: new Set<string>() }),

  incrementReconnectAttempts: () =>
    set((state) => ({ reconnectAttempts: state.reconnectAttempts + 1 })),

  resetReconnectAttempts: () =>
    set({ reconnectAttempts: 0 }),
}));
